<div class="container default-container popup-content" style="width: 65%;">
    <div class="popup-header row">
      <h2 class="col h-small">선결제 충전하기</h2>
      <a href="javascript:;" class="col-auto close-popup-btn" (click)="handleOnClickClosePopup();">
        <svg width="22" height="22" viewBox="0 0 22 22">
          <path d="M1 1L21 21" />
          <path d="M21 1L1 21" />
        </svg>
      </a>
    </div>

    <div class="popup-body">
      <div class="container default-container results searching-result">
        <div class="table-container" style="max-height: 50%;">
          <div class="prepayWrap" id="make-a-payment" style="padding-top: 0px;">
            <form [formGroup]="formPrepayPopup" autocomplete="off">
                <!-- 5. payment method -->
                <div class="prepayCont office-form row container">
                    <div class="col-12 col-sm-6 col-md-8">
                        <dl class="prepayinfo">
                            <dt>보유중인 선결제액</dt>
                            <dd>
                                <input type="text" value="{{ totalPrepay | setComma }}"  formControlName="cardAmt" style="width: calc(100% - 20px);"readonly>
                                <span class="won">원</span>
                            </dd>
                        </dl>
                        <dl class="prepayinfo">
                            <dt>결제 금액</dt>
                            <dd>
                                <input type="text" formControlName="cardAmt" style="width: calc(100% - 20px);"
                                    (keyup)="handleOnKeyUpNumber($event.target)" placeholder="결제 금액">
                                <span class="won">원</span>
                            </dd>
                        </dl>
                    </div>
                    <div class="col-12 col-sm-6  col-md-4 imgCard">
                        <dd><img src="./assets/img/creditcard.png" alt="선결제"></dd>
                    </div>
                </div>
                <div class="prepayCont office-form">
                    <div class="prepayCard form-card" formGroupName="card">
                        <dl class="prepayinfo">
                            <dt>카드종류</dt>
                            <dd>
                                <select name="" id="cards-selection-prepay">
                                    <option class="w-card-prepay selected" value="1" data-index="1">일반카드</option>
                                    <option class="w-card-prepay" value="2" data-index="2">법인카드</option>
                                </select>
                            </dd>
                        </dl>

                        <div class="card-type general-card active" data-card="1" formGroupName="personal">
                            <!-- Personal Card -->
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>카드번호</dt>
                                        <dd>
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo1" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo2" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo3" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo4" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                        </dd>
                                    </dl>
                                </div>
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>생년월일</dt>
                                        <dd>
                                            <input type="text" maxlength="6" formControlName="birthday"
                                                (keyup)="handleOnKeyUpNumber($event.target)" autocomplete="off" placeholder="6자리">
                                            <span>생년월일(6자리)</span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>소유주</dt>
                                        <dd>
                                            <input type="text" formControlName="cardHolder" placeholder="소유주">
                                        </dd>
                                    </dl>
                                </div>
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>카드비밀번호</dt>
                                        <dd>
                                            <input type="password" maxlength="2" class="input-2-digits"
                                                formControlName="cardPassword" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="current-password" placeholder="XX">
                                            <span class="text-primary"> ** (앞2자리)</span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>유효기간</dt>
                                        <dd>
                                            <input type="text" class="col col-sm-auto input-2-digits" maxlength="2"
                                                formControlName="cardMM" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="MM">
                                            <span class="col-auto unit"> 월 / </span>
                                            <input type="text" class="col col-sm-auto input-2-digits" maxlength="4"
                                                formControlName="cardYY" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="YYYY">
                                            <span class="col-auto unit"> 년</span>
                                        </dd>
                                    </dl>
                                </div>
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>할부기간</dt>
                                        <dd>
                                            <select formControlName="cardInstall">
                                                <option *ngFor="let item of personalCardInstallOptions"
                                                    [value]="item.value">{{item.label}}</option>
                                            </select>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <!-- End Personal Card -->
                        </div>

                        <div class="card-type corporation-card" data-card="2" formGroupName="general">
                            <!-- General Card -->
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>카드번호</dt>
                                        <dd>
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo1" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo2" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo3" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                            <input type="text" class="col input-4-digits" maxlength="4"
                                                formControlName="cardNo4" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="XXXX">
                                        </dd>
                                    </dl>
                                </div>
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>사업자번호</dt>
                                        <dd>
                                            <input type="text" class="input-10-digits" maxlength="10"
                                                formControlName="birthday" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="10자리">
                                            <span>사업자번호(10자리)</span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>소유주</dt>
                                        <dd>
                                            <input type="text" formControlName="cardHolder" placeholder="소유주">
                                        </dd>
                                    </dl>
                                </div>
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>카드비밀번호</dt>
                                        <dd>
                                            <input type="password" maxlength="2" class="input-2-digits"
                                                formControlName="cardPassword" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="current-password" placeholder="XX">
                                            <span> ** (앞2자리)</span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>유효기간</dt>
                                        <dd>
                                            <input type="text" class="col col-sm-auto input-2-digits" maxlength="2"
                                                formControlName="cardMM" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="MM">
                                            <span class="col-auto unit"> 월 / </span>
                                            <input type="text" class="col col-sm-auto input-2-digits" maxlength="4"
                                                formControlName="cardYY" (keyup)="handleOnKeyUpNumber($event.target)"
                                                autocomplete="off" placeholder="YYYY">
                                            <span class="col-auto unit"> 년</span>
                                        </dd>
                                    </dl>
                                </div>
                                <div class="col-12 col-md-6">
                                    <dl class="prepayinfo">
                                        <dt>할부기간</dt>
                                        <dd>
                                            <select formControlName="cardInstall">
                                                <option *ngFor="let item of generalCardInstallOptions" [value]="item.value">
                                                    {{item.label}}</option>
                                            </select>
                                            <span>(5만원이상 할부가능)</span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <!-- End General Card -->
                        </div>
                    </div>

                    <div class="row group-btns">
                        <a href="javascript:;" (click)="handleOnSubmit();" class="col-auto w-btn medium-btn primary-btn">
                            <span>결제승인</span>
                        </a>
                    </div>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</div>
